export default "/images/logo-12.png?39a09f5291183c8a6c427e3b7cac1da3";